import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { coerceNumber } from '@partners/utils';
import { IRangeValidationHandler, TValidatorError } from '../../model';

export function maxNumericValidator(args: Partial<IRangeValidationHandler<number>>): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const { value, invalid } = control;
    const { max } = args;

    if (invalid) return null;

    const validNumber = coerceNumber(value);
    if (!validNumber) {
      return null;
    }

    if (validNumber > max) {
      const vldResponse: TValidatorError = { maxNumber: value };
      return vldResponse;
    }

    return null;
  };
}
